<template>
	<div class="left-box-progressbar">
		<div
			v-if="!offer.questCompleted"
			class="left-box-progressbar__progress"
		>
			<span class="left-box-progressbar__percentage">
				{{ `${offer.questPercentageProgress}%` }}
			</span>

			<div
				class="left-box-progressbar__bar"
				:style="{ width: `${offer.questPercentageProgress}%` }"
			/>
		</div>

		<div v-else class="left-box-progressbar__completed">
			<ShrinkText
				:text="translate('ui.open')"
				containerClassList="left-box-progressbar__cta"
				:fontSize="14"
				isBold
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
import ShrinkText from "@/components/ShrinkText.vue";
import type { ExtendedPiggyBankOffer } from "@/services/OfferProvider";
import { translate } from "@/utils/translate";

interface Props {
	offer: ExtendedPiggyBankOffer;
}

const { offer } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.left-box-progressbar {
	position: absolute;
	bottom: 0.125rem;
	left: 0.35rem;
	clip-path: polygon(0 12%, 4% 0, 97% 0, 100% 12%, 100% 100%, 0 100%);
	width: 3.625rem;
	height: 1.125rem;
	@include flex-row-center;
	overflow: hidden;

	&__completed,
	&__progress {
		@include flex-row-center;
		padding: 0 0.25rem;
		width: 100%;
	}

	&__percentage,
	&__cta {
		position: relative;
		z-index: 1;
		color: #f4d278;
		font-size: 0.75rem;
		line-height: 0.75rem;
		text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
		text-transform: uppercase;
	}

	&__bar {
		position: absolute;
		top: 0;
		left: 0;
		background-image: linear-gradient(to top, #13204e, #2e5eaf);
		width: 3.625rem;
		height: 1.125rem;
	}
}
</style>
